import React from "react";
import { useTranslation } from "react-i18next";
import SubTitle from "components/SubTitle";
import LinePieChart from "common/components/LinePieChart/LinePieChart";
import { Image } from "react-bootstrap";
import downloadFile from "assets/images/downloadFile.png";
import dotsPencil from "assets/images/dots&pencil.png";
import { usersAppStatusTypes } from "pages/Dashboards/types";
import { getChartDataArray } from "../OnlineDashboard/utils";

const INNER_RADIUS = 80;
const OUTER_RADIUS = 95;

type Props = {
  data: usersAppStatusTypes;
};

const UsersAppStatus = ({ data }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="users-app-container data-box">
      <SubTitle className="title">{t("appData")}</SubTitle>

      <div className="charts-container">
        <div className="pie-container dashed-inner-border">
          <LinePieChart
            innerRadius={INNER_RADIUS}
            outerRadius={OUTER_RADIUS}
            innerText={t("wereRegistered")}
            data={getChartDataArray(
              data,
              "uuidBasedUserPercentage",
              "wereRegistered"
            )}
            percent={data?.uuidBasedUserPercentage}
          />
          <div className="data-container">
            <Image src={downloadFile} width={25} />
            <p className="amount">{data.uuidsCount}</p>
            <p className="chart-title">{t("downloaded")}</p>
          </div>
        </div>

        <div className="pie-container dashed-inner-border">
          <LinePieChart
            innerRadius={INNER_RADIUS}
            outerRadius={OUTER_RADIUS}
            innerText={t("wereVerified")}
            data={getChartDataArray(
              data,
              "usersBasedMimshalZaminVerifyPercentage",
              "wereVerified"
            )}
            percent={data?.usersBasedMimshalZaminVerifyPercentage}
          />
          <div className="data-container">
            <Image src={dotsPencil} width={30} />
            <p className="amount">{data.usersCount}</p>
            <p className="chart-title">{t("wereRegistered")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsersAppStatus;
